// tslint:disable
import * as React from 'react'
import WKloadMore from '../WKloadMore/WKloadMore'

interface WKInfiniteScrollProp {
  onTouchBottom: () => void | null,
  isStop: boolean,
  distance: number,
  isKill: boolean,
  isShowLoading: boolean,
  el ?: object | null
  scrollTopRec: (t: any) => any
}

export class Infinite extends React.Component <WKInfiniteScrollProp, any> {
  constructor(props: any) {
    super(props)
    this.handleScroll = this.handleScroll.bind(this)
  }

  public componentDidMount() {
    this.props.el || window.addEventListener('scroll', this.handleScroll)
  }
  public componentWillUnmount() {
    this.props.el || window.removeEventListener('scroll', this.handleScroll)
  }
  public handleScroll = () => {
    if (this.props.isStop) {
      return
    }
    if (this.isTouchBottom()) {
      this.props.onTouchBottom()
    }
  }

  public getScrollTopElement(): HTMLElement {
    return (document.documentElement as HTMLElement)
  }

  public getScrollTop() {
    const {scrollTopRec} = this.props
    const scrollTops = document.body.scrollTop + document.documentElement.scrollTop;
    scrollTopRec && scrollTopRec(scrollTops);
    if (this.props.el || window === window) {
      return document.body.scrollTop || this.getScrollTopElement().scrollTop
    } else {
      return (this.props.el || document.body).scrollTop
    }
  }

  public getScrollHeight() {
    if (this.props.el || window === window) {
      return document.body.scrollHeight
    } else {
      return this.props.el || document.body.scrollHeight
    }
  }
  public getWindowHeight = () => {
    if (this.props.el || window === window) {
      return this.getScrollTopElement().clientHeight
    } else {
      return this.props.el || document.body.getBoundingClientRect().height
    }
  }
  public isTouchBottom = () => {
    const distance = this.props.distance
    return this.getScrollTop() + this.getWindowHeight() + distance >= this.getScrollHeight()
  }
  public renderLoading = () => {
    return (
      <div className="WKInfiniteScroll">
        {(!this.props.isKill && this.props.isStop) && <WKloadMore/>}
        {this.props.isKill && <div>没有更多了</div>}
      </div>
    )
  }
  public render() {
    return (
      this.renderLoading()
    )
  }
}

export default function(props: any) {
  if (props.isShowLoading && !props.isKill) {
    return <Infinite {...props} />
  }
  if (props.isKill) {
    return null
  } else {
    return <Infinite {...props} />
  }
}



// WEBPACK FOOTER //
// ./src/components/WKInfiniteScroll/WKInfiniteScroll.tsx